export default __webpack_public_path__ + "static/gouv-69641610bb4b3e8387509ebd27efe973.png";